import { render, staticRenderFns } from "./Top-Header.vue?vue&type=template&id=04ff100d&scoped=true&"
import script from "./Top-Header.vue?vue&type=script&lang=js&"
export * from "./Top-Header.vue?vue&type=script&lang=js&"
import style0 from "./Top-Header.vue?vue&type=style&index=0&id=04ff100d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff100d",
  null
  
)

export default component.exports